import { render, staticRenderFns } from "./TheTitle.vue?vue&type=template&id=124f9f91&"
import script from "./TheTitle.vue?vue&type=script&lang=js&"
export * from "./TheTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports